import { gerkService } from '../services/gerk.service';


const state = {
    kmrs: null,
    item:null,
    gerkRKG:null,
    gerkZS:null
};

const actions = {
    load({ commit },{sezona,gerkpid}) {
        commit('load');

       return gerkService.loadKMRS(sezona,gerkpid)
            .then(
                kmrs => commit('load', kmrs)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     loadGerkRKG({ commit },{sezona,gerkpid}) {
        commit('load');

       return gerkService.loadGerkRKG(sezona,gerkpid)
            .then(
                gerkRKG => commit('loadGerkRKG', gerkRKG)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     loadGerkZS({ commit },{sezona,gerkpid}) {
        commit('load');

       return gerkService.loadGerkZS(sezona,gerkpid)
            .then(
                gerkZS => commit('loadGerkZS', gerkZS)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    }
  
};

const mutations = {
  
    load(state, kmrs) {
        state.kmrs = kmrs;
    },
    loadGerkRKG(state, gerkRKG) {
        state.gerkRKG = gerkRKG;
    },
    loadGerkZS(state, gerkZS) {
        state.gerkZS = gerkZS;
    }
    
   
};

export const kmrs = {
    namespaced: true,
    state,
    actions,
    mutations
};
